import React, { useMemo } from 'react'

import { API_URL } from '../constants'

import { useItems } from '../../hooks'

import FormField, { FIELD_TYPES } from '../../components/FormField'

const IncidentTypeSelectList = ({
  field: { label, name, defaultValue },
  item,
  onChange,
}) => {
  const [{ response: incidentTypes, isLoading, error }] = useItems(API_URL)

  const field = useMemo(() => {
    if (isLoading || error || !incidentTypes) return null
    return {
      type: FIELD_TYPES.SELECT,
      label: label || 'Incident Type',
      name,
      defaultValue,
      options: incidentTypes.map((p) => ({
        label: p.name,
        value: p.id,
      })),
    }
  }, [name, label, defaultValue, incidentTypes, isLoading, error])

  if (field === null)
    return (
      <div>
        <label>{label}</label>
        <div>
          Loading Incident Types... <i className="fa fa-spinner fa-spin"></i>
        </div>
      </div>
    )

  return <FormField field={field} item={item} onChange={onChange} />
}

export default IncidentTypeSelectList
